import React, { useState, useEffect } from "react";
import Select from "react-select";

const EditPurchaseItemTable = ({
  items,
  setItems,
  optionsProduct,
  isSupplierSelected,
}) => {

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    const item = updated[index];

    if (field === "item_name") {
      item.item_name = value;

      const selected = optionsProduct.find((p) => p.value === value?.value);

      item.stock = Number(selected?.stock || null);
      item.quantity = null;
      item.rate = null;
      item.total = null;
    } else if (field === "quantity") {
      item.quantity = Number(value) || null;
      item.total = item.quantity * item.rate;
    } else if (field === "rate") {
      item.rate = Number(value) || null;
      item.total = item.quantity * item.rate;
    }

    setItems(updated);
  };

  const handleAdd = () => {
    setItems([
      ...items,
      { item_name: null, stock: null, quantity: null, rate: null, total: null },
    ]);
  };

  const handleRemove = (index) => {
    if (items.length > 1) {
      setItems(items.filter((_, i) => i !== index));
    }
  };

  const getAvailableOptions = (currentIndex) => {
    const selectedProductIds = items
      .map((it, idx) => (idx !== currentIndex ? it.item_name?.value : null))
      .filter(Boolean);

    return optionsProduct.filter((opt) => !selectedProductIds.includes(opt.value));
  };

  const [noOptions, setNoOptions] = useState(false);

  const availableOptions = getAvailableOptions();

  useEffect(() => {
    setNoOptions(availableOptions.length === 0);
  }, [availableOptions.length]);
  

  return (
    <div className="col-12">
      <div className="d-flex justify-content-end my-2">
        <button
          type="button"
          className="btn btn-success btn-sm"
          onClick={handleAdd}
          disabled={!isSupplierSelected || noOptions}
        >
          Add More Item
        </button>
      </div>

      <table className="table table-bordered align-middle purchase-item-table">
        <thead className="table-light">
          <tr>
            <th>Item</th>
            <th>Stock</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td>
                <Select
                  classNamePrefix="react-select"
                  placeholder="Select Item"
                  value={item.item_name}
                  onChange={(v) => handleItemChange(index, "item_name", v)}
                  options={getAvailableOptions(index)}
                  isClearable
                  isDisabled={!isSupplierSelected}
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control text-end"
                  placeholder="0"
                  value={item.stock}
                  readOnly
                  min={0}
                  disabled
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control text-end"
                  placeholder="0"
                  value={item.quantity}
                  onChange={(e) =>
                    handleItemChange(index, "quantity", e.target.value)
                  }
                  min={0}
                  disabled={!item.item_name}
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control text-end"
                  placeholder="0"
                  value={item.rate}
                  onChange={(e) =>
                    handleItemChange(index, "rate", e.target.value)
                  }
                  min={0}
                  disabled={!item.item_name}
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control text-end"
                  placeholder="0"
                  value={item.total}
                  readOnly
                  min={0}
                  disabled
                />
              </td>

              <td className="text-center">
                {items.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-circle"
                    onClick={() => handleRemove(index)}
                  >
                    <i class="bi bi-x fs-6"></i>
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EditPurchaseItemTable;
